module.exports = __webpack_public_path__ + "img/黑科技 1@2x.ff961506.png";